import * as React from 'react';
import type { SVGProps } from 'react';
import type { IconProps, ForwardedIconComponent } from './types';
const TagFilled = (React.forwardRef<SVGSVGElement, SVGProps<SVGSVGElement> & IconProps>(function TagFilled({
  title = 'Tag',
  titleId,
  size = '1em',
  ...props
}, ref) {
  return <svg width={size} height={size} viewBox="0 0 24 24" fill="none" ref={ref} aria-labelledby={titleId} {...props}>
        {title === undefined ? <title id={titleId}>{'Tag'}</title> : title ? <title id={titleId}>{title}</title> : null}
        <path d="m10 24 12-12V2H12L0 14l10 10Z" fill="currentColor" />
      </svg>;
}) as ForwardedIconComponent);
export default TagFilled;